import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-72659236"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "overflow-hidden" }
const _hoisted_2 = {
  class: "bg-white position-relative overflow-auto mw-100 pb-6",
  style: {"max-height":"650px"}
}
const _hoisted_3 = { class: "table table-bordered" }
const _hoisted_4 = { class: "sticky-top bg-white" }
const _hoisted_5 = { class: "position-relative border-0" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "p-2" }, "Дата тендера", -1))
const _hoisted_7 = {
  key: 1,
  class: "p-2"
}
const _hoisted_8 = { class: "position-relative border-0" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "p-2" }, "Дата заезда", -1))
const _hoisted_10 = {
  key: 1,
  class: "p-2"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "p-2" }, "Клиент", -1))
const _hoisted_12 = {
  key: 1,
  class: "p-2"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "p-2" }, "ПС", -1))
const _hoisted_14 = {
  key: 1,
  class: "p-2"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "p-2" }, "Гос.номер", -1))
const _hoisted_16 = {
  key: 1,
  class: "p-2"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "p-2" }, "Вид ремонта", -1))
const _hoisted_18 = {
  key: 1,
  class: "p-2"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "p-2" }, "Стоимость без НДС", -1))
const _hoisted_20 = {
  key: 1,
  class: "p-2"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "p-2" }, "НДС", -1))
const _hoisted_22 = {
  key: 1,
  class: "p-2"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "p-2" }, "Стоимость с НДС", -1))
const _hoisted_24 = {
  key: 1,
  class: "p-2"
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "p-2" }, "Себестоимость (без НДС)", -1))
const _hoisted_26 = {
  key: 1,
  class: "p-2"
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "p-2" }, "Маржа (тенге)", -1))
const _hoisted_28 = {
  key: 1,
  class: "p-2"
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "p-2" }, "Рентабельность (%)", -1))
const _hoisted_30 = {
  key: 1,
  class: "p-2"
}
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "p-2" }, "Примечание", -1))
const _hoisted_32 = {
  key: 1,
  class: "p-2"
}
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "p-2" }, "Согласование", -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_35 = {
  key: 0,
  class: "d-flex flex-column align-items-start"
}
const _hoisted_36 = ["data-project-id", "data-status"]
const _hoisted_37 = ["data-project-id", "data-status"]
const _hoisted_38 = {
  key: 1,
  class: "p-2"
}

import { reactive, onMounted } from 'vue';
import { APPROVAL_STATUS, APPROVAL_STATUS_COLLECTION } from '@depo/constants/project-register';
import { ROLE } from '@depo/constants/user';
import api from '@/api';
import PopoverUi from '@/components/ui/PopoverUi.vue';
import { IProjectRegister } from '@/@types/IProjectRegister';
import formatDate from '@/utils/formatDate';
import { userStore } from '@/store/userStore';
import { useModal } from '@/composables/useModal';
import formatMoney from '@/utils/formatMoney';

type stateType = {
    projectRegisters: Array<IProjectRegister>;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'ProjectScheduleComponent',
  setup(__props) {

const state: stateType = reactive({
    projectRegisters: [],
});

const { user } = userStore();

function getProjectRegisters() {
    return api.projectRegister.getMany().then(({ data }) => {
        state.projectRegisters = data;
    });
}

function getContractTerms(project: IProjectRegister) {
    return `
    Аванс:\xa0${project.advancePercent}<br />
    Оплата\xa0после\xa0сдачи:\xa0${project.daysToGetPaidAfterActOfWorkPerformedSubmit}\xa0дн.<br />
    Срок\xa0ремонта:\xa0${project.repairPeriodDays}\xa0дн.<br />
    Полная\xa0оплата:\xa0${project.fullPayment}<br />
    Пеня\xa0за\xa0простой:\xa0${project.demuragePenalty}`;
}

function getConstructivePrices(project: IProjectRegister) {
    return project.constructivePrices.reduce((text, { total, constructive: { nm, group_name } }) => {
        if (!total) return text;

        return text + `${nm}. ${group_name}:\xa0${formatMoney(total, 0, '.', '\xa0')}<br />`;
    }, '');
}

function handleApprove(e: Event) {
    const currentTarget = e.currentTarget as HTMLButtonElement;
    const { status, projectId } = currentTarget.dataset;
    if (!status || !APPROVAL_STATUS_COLLECTION.includes(status) || !projectId) {
        return;
    }

    useModal('text_modal')
        .open({
            title: 'Согласование: ' + status,
            btn: 'Сохранить',
            value: '',
            label: 'Комментарий',
        })
        .then((r: any) => {
            return api.projectRegister.approve(+projectId, {
                status,
                comment: r.value,
            });
        })
        .then(getProjectRegisters)
        .catch(console.error);
}

onMounted(getProjectRegisters);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("table", _hoisted_3, [
        _createElementVNode("thead", _hoisted_4, [
          _createElementVNode("tr", _hoisted_5, [
            _hoisted_6,
            (state.projectRegisters.length)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(state.projectRegisters, (project) => {
                  return (_openBlock(), _createElementBlock("th", {
                    key: project.id,
                    class: "p-2"
                  }, [
                    _createVNode(PopoverUi, {
                      class: "text-decoration-underline",
                      content: 
                                    'ОИД:\xa0' +
                                    project.oidPercent +
                                    '%,\xa0квал.требования: ' +
                                    (project.qualificationRequirements || '-')
                                
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(formatDate)(project.tenderStartsAt)), 1)
                      ]),
                      _: 2
                    }, 1032, ["content"])
                  ]))
                }), 128))
              : (_openBlock(), _createElementBlock("th", _hoisted_7, "Данных нет"))
          ])
        ]),
        _createElementVNode("tbody", null, [
          _createElementVNode("tr", _hoisted_8, [
            _hoisted_9,
            (state.projectRegisters.length)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(state.projectRegisters, (project) => {
                  return (_openBlock(), _createElementBlock("th", {
                    key: project.id,
                    class: "p-2"
                  }, _toDisplayString(_unref(formatDate)(project.entersAt)), 1))
                }), 128))
              : (_openBlock(), _createElementBlock("th", _hoisted_10, "Данных нет"))
          ]),
          _createElementVNode("tr", null, [
            _hoisted_11,
            (state.projectRegisters.length)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(state.projectRegisters, (project) => {
                  return (_openBlock(), _createElementBlock("td", {
                    key: project.id,
                    class: "p-2"
                  }, [
                    _createVNode(PopoverUi, {
                      class: "text-decoration-underline",
                      content: getContractTerms(project)
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(project.contractor.name?.replaceAll(' ', '\xa0').replaceAll('-', '‑')), 1)
                      ]),
                      _: 2
                    }, 1032, ["content"])
                  ]))
                }), 128))
              : (_openBlock(), _createElementBlock("td", _hoisted_12, "Данных нет"))
          ]),
          _createElementVNode("tr", null, [
            _hoisted_13,
            (state.projectRegisters.length)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(state.projectRegisters, (project) => {
                  return (_openBlock(), _createElementBlock("td", {
                    key: project.id,
                    class: "p-2"
                  }, _toDisplayString(project.locomotiveModel.name), 1))
                }), 128))
              : (_openBlock(), _createElementBlock("td", _hoisted_14, "Данных нет"))
          ]),
          _createElementVNode("tr", null, [
            _hoisted_15,
            (state.projectRegisters.length)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(state.projectRegisters, (project) => {
                  return (_openBlock(), _createElementBlock("td", {
                    key: project.id,
                    class: "p-2"
                  }, _toDisplayString(project.locomotive?.number || ''), 1))
                }), 128))
              : (_openBlock(), _createElementBlock("td", _hoisted_16, "Данных нет"))
          ]),
          _createElementVNode("tr", null, [
            _hoisted_17,
            (state.projectRegisters.length)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(state.projectRegisters, (project) => {
                  return (_openBlock(), _createElementBlock("td", {
                    key: project.id,
                    class: "p-2"
                  }, _toDisplayString(project.jobCategory.name?.replaceAll('-', '‑')), 1))
                }), 128))
              : (_openBlock(), _createElementBlock("td", _hoisted_18, "Данных нет"))
          ]),
          _createElementVNode("tr", null, [
            _hoisted_19,
            (state.projectRegisters.length)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(state.projectRegisters, (project) => {
                  return (_openBlock(), _createElementBlock("td", {
                    key: project.id,
                    class: "p-2"
                  }, _toDisplayString(_unref(formatMoney)(project.totalWithoutVAT, 0, '.', '\xa0')), 1))
                }), 128))
              : (_openBlock(), _createElementBlock("td", _hoisted_20, "Данных нет"))
          ]),
          _createElementVNode("tr", null, [
            _hoisted_21,
            (state.projectRegisters.length)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(state.projectRegisters, (project) => {
                  return (_openBlock(), _createElementBlock("td", {
                    key: project.id,
                    class: "p-2"
                  }, _toDisplayString(_unref(formatMoney)(project.vat, 0, '.', '\xa0')), 1))
                }), 128))
              : (_openBlock(), _createElementBlock("td", _hoisted_22, "Данных нет"))
          ]),
          _createElementVNode("tr", null, [
            _hoisted_23,
            (state.projectRegisters.length)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(state.projectRegisters, (project) => {
                  return (_openBlock(), _createElementBlock("td", {
                    key: project.id,
                    class: "p-2"
                  }, _toDisplayString(_unref(formatMoney)(project.total, 0, '.', '\xa0')), 1))
                }), 128))
              : (_openBlock(), _createElementBlock("td", _hoisted_24, "Данных нет"))
          ]),
          _createElementVNode("tr", null, [
            _hoisted_25,
            (state.projectRegisters.length)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(state.projectRegisters, (project) => {
                  return (_openBlock(), _createElementBlock("td", {
                    key: project.id,
                    class: "p-2"
                  }, [
                    _createVNode(PopoverUi, {
                      class: "text-decoration-underline",
                      content: getConstructivePrices(project)
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(formatMoney)(project.costPrice, 0, '.', '\xa0')), 1)
                      ]),
                      _: 2
                    }, 1032, ["content"])
                  ]))
                }), 128))
              : (_openBlock(), _createElementBlock("td", _hoisted_26, "Данных нет"))
          ]),
          _createElementVNode("tr", null, [
            _hoisted_27,
            (state.projectRegisters.length)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(state.projectRegisters, (project) => {
                  return (_openBlock(), _createElementBlock("td", {
                    key: project.id,
                    class: "p-2"
                  }, _toDisplayString(_unref(formatMoney)(project.margin, 0, '.', '\xa0')), 1))
                }), 128))
              : (_openBlock(), _createElementBlock("td", _hoisted_28, "Данных нет"))
          ]),
          _createElementVNode("tr", null, [
            _hoisted_29,
            (state.projectRegisters.length)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(state.projectRegisters, (project) => {
                  return (_openBlock(), _createElementBlock("td", {
                    key: project.id,
                    class: "p-2"
                  }, _toDisplayString(_unref(formatMoney)(project.profitability, 0, '.', '\xa0')), 1))
                }), 128))
              : (_openBlock(), _createElementBlock("td", _hoisted_30, "Данных нет"))
          ]),
          _createElementVNode("tr", null, [
            _hoisted_31,
            (state.projectRegisters.length)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(state.projectRegisters, (project) => {
                  return (_openBlock(), _createElementBlock("td", {
                    key: project.id,
                    class: "p-2"
                  }, _toDisplayString(project.comment), 1))
                }), 128))
              : (_openBlock(), _createElementBlock("td", _hoisted_32, "Данных нет"))
          ]),
          _createElementVNode("tr", null, [
            _hoisted_33,
            (state.projectRegisters.length)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(state.projectRegisters, (project) => {
                  return (_openBlock(), _createElementBlock("td", {
                    key: project.id,
                    class: "p-2",
                    style: {"white-space":"pre-line"}
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(project.approvals, (approval) => {
                      return (_openBlock(), _createElementBlock("span", {
                        key: approval.id
                      }, [
                        _createElementVNode("b", null, _toDisplayString(approval.user.login), 1),
                        _createTextVNode(" :" + _toDisplayString(` ${approval?.status}, ${_unref(formatDate)(approval?.updatedAt)} \n\
                            Комментарий: ${approval?.comment}\n`), 1)
                      ]))
                    }), 128)),
                    _hoisted_34,
                    (
                                    !project.approvals.some(
                                        (app) => app.userId === _unref(user).id && app.status === _unref(APPROVAL_STATUS).APPROVE,
                                    ) &&
                                    [_unref(ROLE).ADMIN.VALUE, _unref(ROLE).CEO.VALUE, _unref(ROLE).SUPER_ADMIN.VALUE].includes(_unref(user).roleId)
                                )
                      ? (_openBlock(), _createElementBlock("span", _hoisted_35, [
                          _createElementVNode("button", {
                            class: "btn bg-primary bg-opacity-50 mb-2",
                            "data-project-id": project.id,
                            "data-status": _unref(APPROVAL_STATUS).APPROVE,
                            onClick: handleApprove
                          }, " Согласовать ", 8, _hoisted_36),
                          _createElementVNode("button", {
                            class: "btn btn-outline-danger bg-opacity-50",
                            "data-project-id": project.id,
                            "data-status": _unref(APPROVAL_STATUS).REJECTED,
                            onClick: handleApprove
                          }, "   Отклонить   ", 8, _hoisted_37)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              : (_openBlock(), _createElementBlock("td", _hoisted_38, "Данных нет"))
          ])
        ])
      ])
    ])
  ]))
}
}

})